<mat-form-field [color]="color" [appearance]="appearance" [floatLabel]="floatLabel">
  @if (label) {
    <mat-label>{{ label }}</mat-label>
  }
  <mat-select
    [formControl]="control"
    [required]="required"
    panelClass="filter-select-panel"
    (selectionChange)="onChange($event)">
    @for (option of filterOptions; track option.value) {
      <mat-option [value]="option.value">{{ option.label }}</mat-option>
    }
  </mat-select>
</mat-form-field>
